import { func, oneOfType, string, number } from 'prop-types'
import React, { Fragment } from 'react'
import '../../../components/library/buttons/Checkbox.scss'
import Skeleton from '../../../components/library/loaders/Skeleton'

const AvailableCheckboxItem = ({ id, label, checked, onCheckChanged }) => {

    const elementId = id ? `chk-available-${id}` : 'loader'

    const handleClick = (e) => {
        if (id && onCheckChanged) {
            onCheckChanged(id, !checked)
        }
    }

    return (
        <label className='spark-cb px-1 py-1 office-list-item' onClick={(e) => handleClick(e)}>
            {id && label ?
                <Fragment>
                    <input type='checkbox' id={elementId} onClick={e => e.stopPropagation()} defaultChecked={Boolean(checked)} />
                    <label htmlFor={elementId} className='cb-label p2' title={label}>
                        <span className='is-unselectable truncate-text'>{label}</span>
                    </label>
                </Fragment>
                :
                <Fragment>
                    <input type='checkbox' id={elementId} onClick={e => e.stopPropagation()} defaultChecked={Boolean(checked)} />
                    <label htmlFor={elementId} className='cb-label p2'>
                        <span><Skeleton width='200px' /></span>
                    </label>
                </Fragment>
            }
        </label>
    )
}

AvailableCheckboxItem.propTypes = {
    id: oneOfType([string, number]),
    label: string,
    onCheckChanged: func
}

export default AvailableCheckboxItem